import React from "react";
import { Grid } from "@material-ui/core";
import numeral from "numeral";
import "./styles.css";

const Step = ({ label, sublabel, details, footer, companyPrimaryColor, companySecondaryColor }) => (
  <Grid container item xs={12} direction="row">
    <div style={{ position: "absolute" }}><div className="refi-circle" style={{ backgroundColor: companySecondaryColor }} /></div>
    <Grid container item xs={12} direction="column" className="refinance-analysis-section-step-wrapper">
      <Grid container item xs={5} direction="column">
        <Grid item><div className="refinance-analysis-step-base refinance-analysis-step-large" style={{ color: companySecondaryColor }}>{label}</div></Grid>
        <Grid item><div className="refinance-analysis-step-base refinance-analysis-step-medium">{sublabel}</div></Grid>
      </Grid>
      <Grid container item xs={7} direction="column" className="refinance-analysis-step-box-wrapper" alignItems="center" style={{ border: `1px solid ${companyPrimaryColor}` }}>
        <Grid item className="refinance-analysis-step-details">{details()}</Grid>
        <Grid item className="refinance-analysis-step-box-footer" style={{ color: companySecondaryColor }}>{footer}</Grid>
      </Grid>
    </Grid>
  </Grid>
);

const RefinanceAnalysis = ({ prepaymentPenalty, costSavingsResult, companyPrimaryColor, companySecondaryColor }) => {
  const netSavings = prepaymentPenalty - costSavingsResult;
  const StepContent = [
    {
      label: "Step One",
      sublabel: "Calculate the Prepayment Penalty",
      details: () => <div>In order to exit the existing financing, we need to assess any penalties for prepaying the loan.</div>,
      footer: `Prepayment Penalty = ${numeral(prepaymentPenalty).format("$0,0")}`
    },
    {
      label: "Step Two",
      sublabel: "Compare the Present Valued Interest Savings of the Existing Financing to the New Financing",
      details: () => <div>
        To compare interest savings, we'll find the present valued sum of interest payments for the rest of the current financing.
        <br />
        <br />
        {" "}
        Then subtract the PV'd interest payments of the
        {" "}
        <i>existing loan amount</i>
        {" "}
        with the
        {" "}
        <i>new interest rate</i>
        , out to the existing
        {" "}
        <strong>12/1/2025</strong>
        {" "}
        maturity.
                     </div>,
      footer: `Interest Savings = ${numeral(costSavingsResult).format("$0,0")}`
    },
    {
      label: "Step Three",
      sublabel: "Subtract for your Net Refinance Savings",
      details: () => <div>
        Subtract your
        <strong>prepayment cost</strong>
        {" "}
        from your
        <strong>interest savings</strong>
        {" "}
        to find out how much you could save by refinancing today.
      </div>,
      footer: `Net Refinancing Savings = ${numeral(netSavings).format("$0,0")}`
    }
  ];

  return (
    <Grid container item direction="row" xs={11}>
      <Grid item xs={12}><div className="refinance-analysis-title" style={{ borderBottom: `1px dashed ${companyPrimaryColor}` }}>Refinance Analysis</div></Grid>
      <Grid container item xs={12} direction="row">
        {StepContent.map((sc, idx) => <Step key={idx} {...sc} companyPrimaryColor={companyPrimaryColor} companySecondaryColor={companySecondaryColor} />)}
      </Grid>
    </Grid>
  );
};

export default RefinanceAnalysis;
